<app-sub-header-text
  *ngIf="trialDays.value != null"
  [title]="'NEW_USER.CREATE_NEW_ACCOUNT' | translate"
  [subtitle]="
    (!isIos ? 'NEW_USER.YOU_WILL_BE_ABLE_TO_USE_THE_APP_FOR_FREE_FOR_A_PEDIOD' : '') | translate: trialDays
  "
></app-sub-header-text>
<form [formGroup]="registerForm" (ngSubmit)="requestNewUser($event)" name="vistoria-novo_usuario">
  <ion-grid>
    <ion-row
      class="ion-align-items-center ion-justify-items-center ion-justify-content-center"
      max-width-form-web
      margin-auto
    >
      <ion-radio-group (ionChange)="radioGroupChange($event)" value="1">
        <div inline-flex>
          <ion-item lines="none">
            <ion-label> {{ 'NEW_USER.PHYSICAL_PERSON' | translate }}</ion-label>
            <ion-radio mode="md" value="1" slot="start" [checked]="selectedRadioGroup === '1'"></ion-radio>
          </ion-item>

          <ion-item lines="none">
            <ion-label> {{ 'NEW_USER.LEGAL_PERSON' | translate }}</ion-label>
            <ion-radio mode="md" value="2" slot="start" [checked]="selectedRadioGroup === '2'"></ion-radio>
          </ion-item>
        </div>
      </ion-radio-group>
      <ion-col size="12">
        <app-accordion
          [tittle]="
            (selectedRadioGroup === '1' ? 'NEW_USER.USER_DATA_REQUIRED' : 'NEW_USER.COMPANY_DATA_REQUIRED')
              | translate
          "
          [arrow]="true"
          [show]="true"
          [toggle]="false"
          formGroupName="user"
        >
          <div class="ion-margin">
            <ion-grid>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col size="12" background-white-md-up>
                  <ion-row class="ion-align-items-center ion-justify-content-start">
                    <ng-container *ngIf="selectedRadioGroup === '1'">
                      <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                        <ion-label position="stacked">{{ 'NEW_USER.NAME' | translate }}</ion-label>
                        <ion-input
                          id="userName"
                          name="userName"
                          type="text"
                          formControlName="userName"
                          placeholder="{{ 'NEW_USER.ENTER_FULL_NAME' | translate }}"
                        >
                        </ion-input>

                        <ion-note color="danger" *ngIf="userName.dirty && userName.errors?.required">
                          {{ 'NEW_USER.ENTER_THE_NAME' | translate }}
                        </ion-note>

                        <ion-note
                          color="danger"
                          *ngIf="userName.dirty && !userName.errors?.required && userName.errors?.maxlength"
                        >
                          {{ 'NEW_USER.THE_NAME_MUST_CONTAIN_AT_MOST' | translate }}
                          {{ userName.errors.maxlength.requiredLength }}
                          {{ 'NEW_USER.CHARACTERS' | translate }}
                        </ion-note>
                      </ion-col>

                      <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                        <ion-label position="stacked">{{ 'NEW_USER.CPF' | translate }}</ion-label>
                        <ion-input
                          type="text"
                          formControlName="cpf"
                          placeholder="{{ 'NEW_USER.ENTER_THE_CPF' | translate }}"
                          mask="cpf"
                          dropSpecialCharacters
                        >
                        </ion-input>

                        <ion-note color="danger" *ngIf="cpf.dirty && cpf.errors?.required">
                          {{ 'NEW_USER.INFORM_THE_CPF' | translate }}
                        </ion-note>

                        <ion-note
                          color="danger"
                          *ngIf="cpf.dirty && !cpf.errors?.required && cpf.errors?.invalidCPF"
                        >
                          {{ 'NEW_USER.INVALID_CPF' | translate }}
                        </ion-note>
                      </ion-col>
                    </ng-container>

                    <ng-container *ngIf="selectedRadioGroup === '2'">
                      <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                        <ion-label position="stacked">{{ 'NEW_USER.CNPJ' | translate }}</ion-label>
                        <ion-input
                          type="text"
                          formControlName="cnpj"
                          placeholder="{{ 'NEW_USER.ENTER_THE_CNPJ' | translate }}"
                          dropSpecialCharacters
                          mask="cnpj"
                        >
                        </ion-input>
                        <ion-note
                          text-left
                          color="danger"
                          class="ion-text-start"
                          *ngIf="cnpj.dirty && cnpj.errors?.required"
                        >
                          {{ 'NEW_USER.INFORM_THE_CNPJ' | translate }}
                        </ion-note>

                        <ion-note
                          color="danger"
                          *ngIf="cnpj.dirty && !cnpj.errors?.required && cnpj.errors?.invalidCNPJ"
                        >
                          {{ 'NEW_USER.INVALID_CNPJ' | translate }}
                        </ion-note>
                      </ion-col>
                      <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                        <ion-label position="stacked">{{ 'NEW_USER.FANTASY_NAME' | translate }}</ion-label>
                        <ion-input
                          type="text"
                          formControlName="userName"
                          placeholder="{{ 'NEW_USER.ENTER_THE_FANCY_NAME' | translate }}"
                        >
                        </ion-input>

                        <ion-note color="danger" *ngIf="userName.dirty && userName.errors?.required">
                          {{ 'NEW_USER.ENTER_THE_TRADE_NAME' | translate }}
                        </ion-note>

                        <ion-note
                          color="danger"
                          *ngIf="userName.dirty && !userName.errors?.required && userName.errors?.maxlength"
                        >
                          {{ 'NEW_USER.THE_NAME_MUST_CONTAIN_AT_MOST' | translate }}
                          {{ userName.errors.maxlength.requiredLength }}
                          {{ 'NEW_USER.CHARACTERS' | translate }}
                        </ion-note>
                      </ion-col>
                    </ng-container>
                    <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                      <ion-label position="stacked">{{ 'NEW_USER.PHONE' | translate }}</ion-label>
                      <ion-input
                        type="text"
                        formControlName="userPhone"
                        placeholder="{{ 'NEW_USER.ENTER_THE_NUMBER_OF_PHONE' | translate }}"
                        mask="tel"
                      >
                      </ion-input>

                      <ion-note color="danger" *ngIf="userPhone.dirty && userPhone.errors?.required">
                        {{ 'NEW_USER.INFORM_THE_PHONE' | translate }}
                      </ion-note>

                      <ion-note
                        color="danger"
                        *ngIf="
                          userPhone.dirty && !userPhone.errors?.required && userPhone.errors?.invalidPhone
                        "
                      >
                        {{ 'NEW_USER.INVALID_PHONE' | translate }}
                      </ion-note>
                    </ion-col>

                    <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                      <ion-label position="stacked">{{ 'NEW_USER.EMAIL' | translate }}</ion-label>
                      <ion-input
                        name="email"
                        type="email"
                        formControlName="userEmail"
                        placeholder="{{ 'NEW_USER.ENTER_THE_LOGIN_EMAIL' | translate }}"
                      >
                      </ion-input>

                      <!-- email required -->
                      <ion-note color="danger" *ngIf="userEmail.dirty && userEmail.errors?.required">
                        {{ 'NEW_USER.ENTER_THE_EMAIL' | translate }}
                      </ion-note>

                      <!-- email invalid -->
                      <ion-note
                        class="ion-text-start"
                        color="danger"
                        *ngIf="userEmail.dirty && userEmail.errors?.email && !userEmail.errors?.required"
                      >
                        {{ 'NEW_USER.INVALID_EMAIL' | translate }}
                      </ion-note>

                      <!-- email max length -->
                      <ion-note
                        class="ion-margin-top ion-text-start"
                        color="danger"
                        *ngIf="
                          userEmail.dirty &&
                          !userEmail.errors?.email &&
                          !userEmail.errors?.required &&
                          userEmail.errors?.maxlength
                        "
                      >
                        {{ 'NEW_USER.THE_EMAIL_MUST_CONTAIN_AT_MOST' | translate }}
                        {{ userEmail.errors.maxlength.requiredLength }}
                        {{ 'NEW_USER.CHARACTERS' | translate }}
                      </ion-note>
                    </ion-col>

                    <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                      <ion-label position="stacked" class="padding-label">
                        {{ 'NEW_USER.NUMBER_OF_REGULATORY_AGENCY' | translate }}</ion-label
                      >
                      <ion-input
                        type="text"
                        formControlName="userResponsibleCreci"
                        placeholder="{{ 'NEW_USER.CRECI_CREA_ETC' | translate }}"
                      >
                      </ion-input>

                      <ion-note
                        color="danger"
                        *ngIf="
                          userResponsibleCreci.dirty &&
                          !userResponsibleCreci.errors?.required &&
                          userResponsibleCreci.errors?.maxlength
                        "
                      >
                        {{ 'NEW_USER.THE_NUMBER_OF_REGULATORY_AGENCY_MUST_CONTAIN_AT_MOST' | translate }}
                        {{ userResponsibleCreci.errors.maxlength.requiredLength }}
                        {{ 'NEW_USER.CHARACTERS' | translate }}
                      </ion-note>
                    </ion-col>

                    <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                      <ion-label position="stacked">{{ 'NEW_USER.PASSWORD' | translate }}</ion-label>
                      <ion-input
                        class="eye"
                        [type]="showPass ? 'text' : 'password'"
                        formControlName="password"
                        autocomplete="off"
                        placeholder="{{ 'NEW_USER.ENTER_YOUR_PASSWORD' | translate }}"
                      >
                        <ion-button class="eye" fill="clear" (click)="showPass = !showPass">
                          <ion-icon slot="icon-only" [name]="showPass ? 'eye-off' : 'eye'"></ion-icon>
                        </ion-button>
                      </ion-input>

                      <!-- password required -->
                      <ion-note
                        class="ion-text-start"
                        color="danger"
                        *ngIf="password.dirty && password.errors?.required"
                      >
                        {{ 'NEW_USER.INFORM_YOUR_PASSWORD' | translate }}
                      </ion-note>

                      <!-- password invalid -->
                      <ion-note
                        class="ion-text-start"
                        color="danger"
                        *ngIf="password.dirty && password.errors?.minlength && !password.errors?.required"
                      >
                        {{ 'NEW_USER.PASSWORD_MUST_CONTAIN' | translate }}
                        {{ password.errors.minlength.requiredLength }}
                        {{ 'NEW_USER.CHARACTERS_OR_MORE' | translate }}
                      </ion-note>

                      <!-- password invalid -->
                      <ion-note
                        class="ion-text-start"
                        color="danger"
                        *ngIf="
                          password.dirty &&
                          password.errors?.maxlength &&
                          !password.errors?.minlength &&
                          !password.errors?.required
                        "
                      >
                        {{ 'NEW_USER.PASSWORD_MUST_CONTAIN_AT_MOST' | translate }}
                        {{ password.errors.maxlength.requiredLength }}
                        {{ 'NEW_USER.CHARACTERS' | translate }}
                      </ion-note>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </app-accordion>
      </ion-col>
      <ion-col size="12">
        <app-accordion
          [tittle]="'NEW_USER.ADDRESS' | translate"
          [arrow]="true"
          [show]="true"
          [toggle]="false"
          formGroupName="masterAdmins"
        >
          <ion-grid>
            <div class="ion-margin">
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col size="12" background-white-md-up>
                  <ion-row class="ion-align-items-center ion-justify-content-start">
                    <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                      <ion-label position="stacked">{{ 'NEW_USER.CEP' | translate }}</ion-label>
                      <ion-input
                        type="tel"
                        formControlName="zipCode"
                        placeholder="{{ 'NEW_USER.ENTER_THE_CEP' | translate }}"
                        mask="zip"
                        dropSpecialCharacters
                      >
                      </ion-input>

                      <ion-note color="danger" *ngIf="zipCode.dirty && zipCode.errors?.required">
                        {{ 'NEW_USER.INFORM_THE_CEP' | translate }}
                      </ion-note>

                      <ion-note
                        color="danger"
                        *ngIf="zipCode.dirty && !zipCode.errors?.required && zipCode.errors?.invalidCep"
                      >
                        {{ 'NEW_USER.INVALID_CEP' | translate }}
                      </ion-note>
                    </ion-col>

                    <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                      <ion-label position="stacked">{{ 'NEW_USER.STATE' | translate }}</ion-label>

                      <ionic-selectable
                        formControlName="state"
                        [items]="statesList"
                        itemValueField="sigla"
                        itemTextField="nome"
                        placeholder="{{ 'NEW_USER.INFORM_THE_STATE' | translate }}"
                        [canSearch]="true"
                        clearButtonText="{{ 'NEW_USER.CLEAN' | translate }}"
                        closeButtonSlot="end"
                        searchPlaceholder="{{ 'NEW_USER.SEARCH' | translate }}"
                        modalCssClass="modal-address"
                        (onSearch)="searchState($event)"
                        (onChange)="stateSelected($event)"
                      >
                        <ng-template ionicSelectableTitleTemplate>
                          <h3 class="ion-text-center ion-text-uppercase text-primary-dark">{{
                            'NEW_USER.SELECT_THE_STATE' | translate
                          }}</h3>
                        </ng-template>
                        <ng-template ionicSelectableCloseButtonTemplate>
                          <ion-icon name="close" color="primary-dark" style="font-size: 24px"></ion-icon>
                        </ng-template>
                        <ng-template ionicSelectableSearchFailTemplate>
                          <div flex class="ion-align-items-center ion-justify-content-center">
                            <h3 class="ion-text-center text-primary-dark ion-no-margin">
                              {{ 'NEW_USER.NO_STATE_FOUND' | translate }}
                            </h3>
                          </div>
                        </ng-template>
                      </ionic-selectable>

                      <ion-note color="danger" *ngIf="state.dirty && state.errors?.required">
                        {{ 'NEW_USER.INFORM_THE_STATE' | translate }}
                      </ion-note>
                    </ion-col>

                    <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                      <ion-label position="stacked">{{ 'NEW_USER.CITY' | translate }}</ion-label>
                      <ionic-selectable
                        formControlName="city"
                        [items]="citiesList"
                        itemValueField="normalized"
                        placeholder="{{ 'NEW_USER.INFORM_CITY' | translate }}"
                        itemTextField="nome"
                        [canSearch]="true"
                        [hasInfiniteScroll]="true"
                        clearButtonText="{{ 'NEW_USER.CLEAN' | translate }}"
                        closeButtonSlot="end"
                        searchPlaceholder="{{ 'NEW_USER.SEARCH' | translate }}"
                        modalCssClass="modal-address"
                        (onSearch)="searchCities($event)"
                        (onInfiniteScroll)="getMoreCities($event)"
                      >
                        <ng-template ionicSelectableTitleTemplate>
                          <h3 class="ion-text-center ion-text-uppercase text-primary-dark">{{
                            'NEW_USER.SELECT_THE_CITY' | translate
                          }}</h3>
                        </ng-template>
                        <ng-template ionicSelectableCloseButtonTemplate>
                          <ion-icon name="close" color="primary-dark" style="font-size: 24px"></ion-icon>
                        </ng-template>
                        <ng-template ionicSelectableSearchFailTemplate>
                          <div flex class="ion-align-items-center ion-justify-content-center">
                            <h3 class="ion-text-center text-primary-dark ion-no-margin">
                              {{ 'NEW_USER.NO_CITY_FOUND' | translate }}
                            </h3>
                          </div>
                        </ng-template>
                      </ionic-selectable>

                      <ion-note color="danger" *ngIf="city.dirty && city.errors?.required">
                        {{ 'COMPONENTS.FORMS.INSERT_CITY' | translate }}
                      </ion-note>
                    </ion-col>

                    <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                      <ion-label position="stacked">{{ 'NEW_USER.NEIGHBORHOOD' | translate }}</ion-label>
                      <ion-input
                        type="text"
                        formControlName="neighborhood"
                        placeholder="{{ 'NEW_USER.ENTER_THE_NEIGHBORHOOD' | translate }}"
                      >
                      </ion-input>

                      <ion-note color="danger" *ngIf="neighborhood.dirty && neighborhood.errors?.required">
                        {{ 'NEW_USER.INFORM_THE_NEIGHBORHOOD' | translate }}
                      </ion-note>

                      <ion-note color="danger" *ngIf="neighborhood.dirty && neighborhood.errors?.maxlength">
                        {{ 'NEW_USER.THE_NEIGHBORHOOD_MUST_HAVE_AT_MOST' | translate }}
                        {{ neighborhood.errors.maxlength.requiredLength }}
                        {{ 'NEW_USER.CHARACTERS' | translate }}
                      </ion-note>
                    </ion-col>

                    <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                      <ion-label position="stacked">{{ 'NEW_USER.ADDRESS' | translate }}</ion-label>
                      <ion-input
                        type="text"
                        formControlName="street"
                        placeholder="{{ 'NEW_USER.ENTER_THE_ADDRESS' | translate }}"
                      >
                      </ion-input>

                      <ion-note color="danger" *ngIf="street.dirty && street.errors?.required">
                        {{ 'NEW_USER.INFORM_THE_ADDRESS' | translate }}
                      </ion-note>

                      <ion-note color="danger" *ngIf="street.dirty && street.errors?.maxlength">
                        {{ 'NEW_USER.THE_ADDRESS_MUST_HAVE_AT_MOST' | translate }}
                        {{ street.errors.maxlength.requiredLength }} {{ 'NEW_USER.CHARACTERS' | translate }}
                      </ion-note>
                    </ion-col>

                    <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                      <ion-label position="stacked">{{ 'NEW_USER.NUMBER' | translate }}</ion-label>
                      <ion-input
                        type="tel"
                        formControlName="streetNumber"
                        placeholder="{{ 'NEW_USER.INFORM_THE_NUMBER' | translate }}"
                      >
                      </ion-input>

                      <ion-note color="danger" *ngIf="streetNumber.dirty && streetNumber.errors?.required">
                        {{ 'NEW_USER.INFORM_THE_NUMBER' | translate }}
                      </ion-note>

                      <ion-note color="danger" *ngIf="streetNumber.dirty && streetNumber.errors?.maxlength">
                        {{ 'NEW_USER.THE_NUMBER_MUST_HAVE_AT_MOST' | translate }}
                        {{ streetNumber.errors.maxlength.requiredLength }}
                        {{ 'NEW_USER.CHARACTERS' | translate }}
                      </ion-note>
                    </ion-col>

                    <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                      <ion-label position="stacked">{{ 'NEW_USER.COMPLEMENT' | translate }}</ion-label>
                      <ion-input
                        type="text"
                        formControlName="complement"
                        placeholder="{{ 'NEW_USER.INSERT_THE_ADD_ON' | translate }}"
                      >
                      </ion-input>

                      <ion-note color="danger" *ngIf="complement.dirty && complement.errors?.maxlength">
                        {{ 'NEW_USER.THE_ADD_ON_MUST_HAVE_AT_MOST' | translate }}
                        {{ complement.errors.maxlength.requiredLength }}
                        {{ 'NEW_USER.CHARACTERS' | translate }}
                      </ion-note>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
            </div>
          </ion-grid>
        </app-accordion>
      </ion-col>
      <ion-col size="12">
        <app-accordion
          [tittle]="'NEW_USER.RESPONSIBLE' | translate"
          [arrow]="true"
          [show]="true"
          [toggle]="false"
          formGroupName="masterAdminResponsibles"
          *ngIf="selectedRadioGroup === '2'"
        >
          <ion-grid>
            <div class="ion-margin">
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                  <ion-label type="text" position="stacked">{{ 'NEW_USER.NAME' | translate }}</ion-label>
                  <ion-input
                    formControlName="masterAdminResponsibleName"
                    placeholder="{{ 'NEW_USER.ENTER_YOUR_NAME' | translate }}"
                  ></ion-input>

                  <!-- responsibleName required -->
                  <ion-note
                    class="ion-text-start"
                    color="danger"
                    *ngIf="responsibleName.dirty && responsibleName.errors?.required"
                  >
                    {{ 'NEW_USER.INFORM_YOUR_NAME' | translate }}
                  </ion-note>

                  <!-- responsibleName max length -->
                  <ion-note
                    class="ion-margin-top ion-text-center"
                    color="danger"
                    *ngIf="
                      responsibleName.dirty &&
                      !responsibleName.errors?.required &&
                      responsibleName.errors?.maxlength
                    "
                  >
                    {{ 'NEW_USER.THE_NAME_MUST_CONTAIN_AT_MOST' | translate }}
                    {{ responsibleName.errors.maxlength.requiredLength }}
                    {{ 'NEW_USER.CHARACTERS' | translate }}
                  </ion-note>
                </ion-col>

                <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                  <ion-label position="stacked">{{ 'NEW_USER.EMAIL_RESPONSIBLE' | translate }}</ion-label>
                  <ion-input
                    type="text"
                    name="responsibleEmail"
                    formControlName="masterAdminResponsibleEmail"
                    placeholder="{{ 'NEW_USER.ENTER_YOUR_EMAIL' | translate }}"
                  >
                  </ion-input>

                  <!-- email required -->
                  <ion-note
                    class="ion-text-start"
                    color="danger"
                    *ngIf="responsibleEmail.dirty && responsibleEmail.errors?.required"
                  >
                    {{ 'NEW_USER.INFORM_YOUR_EMAIL' | translate }}
                  </ion-note>

                  <!-- responsibleName invalid -->
                  <ion-note
                    class="ion-margin-top ion-text-center"
                    color="danger"
                    *ngIf="
                      responsibleEmail.dirty &&
                      responsibleEmail.errors?.email &&
                      !responsibleEmail.errors?.required
                    "
                  >
                    {{ 'NEW_USER.INVALID_EMAIL' | translate }}
                  </ion-note>

                  <!-- email max length -->
                  <ion-note
                    class="ion-margin-top ion-text-center"
                    color="danger"
                    *ngIf="
                      responsibleEmail.dirty &&
                      !responsibleEmail.errors?.email &&
                      !responsibleEmail.errors?.required &&
                      responsibleEmail.errors?.maxlength
                    "
                  >
                    {{ 'NEW_USER.THE_EMAIL_MUST_CONTAIN_AT_MOST' | translate }}
                    {{ responsibleEmail.errors.maxlength.requiredLength }}
                    {{ 'NEW_USER.CHARACTERS' | translate }}
                  </ion-note>
                </ion-col>

                <!-- Phone -->
                <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                  <ion-label position="stacked">{{ 'NEW_USER.PHONE_RESPONSIBLE' | translate }}</ion-label>

                  <ion-input
                    formControlName="masterAdminResponsiblePhone"
                    name="('NEW_USER.PHONE') | translate"
                    id="phone"
                    placeholder="{{ 'NEW_USER.ENTER_THE_NUMBER_OF_PHONE' | translate }}"
                    mask="tel"
                  >
                  </ion-input>

                  <ion-note
                    class="ion-text-start"
                    color="danger"
                    *ngIf="responsiblePhone.dirty && responsiblePhone.errors?.required"
                  >
                    {{ 'NEW_USER.INFORM_THE_PHONE' | translate }}
                  </ion-note>

                  <ion-note
                    class="ion-margin-top ion-text-start"
                    color="danger"
                    *ngIf="
                      responsiblePhone.dirty &&
                      !responsiblePhone.errors?.required &&
                      responsiblePhone.errors?.invalidPhone
                    "
                  >
                    {{ 'NEW_USER.INVALID_PHONE' | translate }}
                  </ion-note>
                </ion-col>

                <ion-col sizeXs="12" sizeXl="6" sizeSm="12" sizeMd="6" sizeLg="6">
                  <ion-label position="stacked">{{ 'NEW_USER.CPF_RESPONSIBLE' | translate }}</ion-label>
                  <ion-input
                    type="text"
                    formControlName="masterAdminResponsibleCpf"
                    placeholder="{{ 'NEW_USER.ENTER_THE_CPF' | translate }}"
                    id="cpf_responsible"
                    mask="cpf"
                  >
                  </ion-input>

                  <ion-note
                    color="danger"
                    class="ion-text-start"
                    *ngIf="responsibleDocument.dirty && responsibleDocument.errors?.required"
                  >
                    {{ 'NEW_USER.INFORM_THE_CPF' | translate }}
                  </ion-note>

                  <ion-note
                    color="danger"
                    *ngIf="
                      responsibleDocument.dirty &&
                      !responsibleDocument.errors?.required &&
                      responsibleDocument.errors?.invalidCPF
                    "
                  >
                    {{ 'NEW_USER.INVALID_CPF' | translate }}
                  </ion-note>
                </ion-col>
              </ion-row>
            </div>
          </ion-grid>
        </app-accordion>
      </ion-col>

      <ion-col size="12" [hidden]="isIos">
        <app-accordion
          [tittle]="'NEW_USER.PROMOTIONAL_COUPON' | translate"
          [arrow]="false"
          [show]="false"
          [toggle]="true"
        >
          <ion-row class="ion-align-items-center ion-justify-content-start">
            <ion-col sizeXs="12" sizeXl="12" sizeSm="12" sizeMd="12" sizeLg="12">
              <div class="ion-margin">
                <ion-label type="text" position="stacked">{{ 'NEW_USER.COUPON' | translate }}</ion-label>
                <ion-input
                  formControlName="couponCode"
                  placeholder="{{ 'NEW_USER.ENTER_COUPON_CODE' | translate }}"
                ></ion-input>
              </div>
            </ion-col>
          </ion-row>
        </app-accordion>
      </ion-col>
      <ion-col flex class="ion-justify-content-center ion-align-items-center">
        <ion-item lines="none">
          <ion-checkbox formControlName="checkbox" color="primary" slot="start"></ion-checkbox>
        </ion-item>
        <div class="terms">
          {{ 'NEW_USER.I_READ_AND_AGREE_WITH_THE' | translate }}
          <a [href]="termsOfUseLink" target="_blank" rel="noopener noreferrer">
            {{ 'NEW_USER.TERMS_OF_USE' | translate }}</a
          >
        </div>
      </ion-col>
      <ion-col size="12" class="ion-padding-top">
        <ion-note color="danger" class="ion-text-center" *ngIf="checkbox.dirty && checkbox.errors?.required">
          {{ 'NEW_USER.TERMS_OF_USE_MUST_BE_ACCEPTED' | translate }}
        </ion-note>
      </ion-col>

      <ion-col size="12" class="ion-padding-top">
        <ion-button type="submit" max-width-300 expand="block" color="buttonPrimary">
          {{ 'NEW_USER.NEW_AN_ACCOUNT' | translate }}
        </ion-button>
      </ion-col>

      <ion-col size="12" class="ion-padding-top">
        <ion-button
          max-width-300
          expand="block"
          fill="clear"
          size="small"
          routerLink="login"
          [routerLinkActive]="['is-active']"
          queryParamsHandling="merge"
        >
          <ion-icon color="white" slot="start" name="arrow-round-back"></ion-icon>
          {{ 'NEW_USER.BACK_TO_LOGIN' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</form>
<ng-template #notFoundTemplateRef let-attrs="attrs">
  <span [innerHTML]="'NEW_USER.NO_RESULTS_FOUND' | translate"></span>
</ng-template>
